import r from "react";
import { propertyCardRecipe as i } from "@huspy/styled-system/recipes";
import "@ark-ui/react";
import { Box as o, Flex as p } from "../../../components/box/index.mjs";
import "../../../components/button/button.mjs";
import "../../../components/checkbox/checkbox.mjs";
import "../../../components/icon-button/icon-button.mjs";
import "../../../components/input/input.mjs";
import "../../../components/input/input-group.mjs";
import "../../../components/phone-input/phone-input.mjs";
import "../../../components/pin-input/pin-input.mjs";
import "../../../components/popover/popover.mjs";
import "../../../components/chip/chip.mjs";
import "../../../components/property-tag/property-tag.mjs";
import "../../../components/slider/slider.mjs";
import "../../../components/alert/alert.mjs";
import { Text as m } from "../../../components/typography/text.mjs";
import "../../../components/typography/title.mjs";
import "../../../components/menu/menu.mjs";
import "../../../components/progress/progress.mjs";
import "../../../components/date-picker/date-picker.mjs";
import "../../../components/tabs/tabs.mjs";
import "../../../components/collapsible/collapsible.mjs";
import "../../../components/dialog/dialog.mjs";
import "../../../components/radio/radio.mjs";
import "../../../components/radio-button/radio-button.mjs";
import "../../../components/file-upload/file-upload.mjs";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "../../../components/table/table.mjs";
import "../../../components/pagination/pagination.mjs";
import "../../../components/combobox/combobox.mjs";
import "../../../components/select/select.mjs";
import "../../../components/badge/badge.mjs";
import "../../../components/property-chip/property-chip.mjs";
import "../../../components/number-input/number-input.mjs";
import "../../../components/switch/switch.mjs";
import "../../../components/toast/base.mjs";
import "lucide-react";
import "../../../components/spinner/spinner.mjs";
import "../../../components/property-badge/property-badge.mjs";
import "../../../components/drawer/drawer.mjs";
import "../../../components/skeleton/skeleton.mjs";
const [a] = i.splitVariantProps({}), e = i(a), s = (t) => /* @__PURE__ */ r.createElement(o, { className: e.root, ...t }), c = (t) => /* @__PURE__ */ r.createElement(o, { className: e.container, ...t }), n = (t) => /* @__PURE__ */ r.createElement(p, { className: e.tags, ...t }), l = (t) => /* @__PURE__ */ r.createElement(o, { className: e.footer, ...t }), d = (t) => (
  // @ts-ignore
  /* @__PURE__ */ r.createElement(m, { size: "md", weight: "medium", className: e.title, ...t })
), P = (t) => (
  // @ts-ignore
  /* @__PURE__ */ r.createElement(m, { size: "md", className: e.description, ...t })
), C = (t) => (
  // @ts-ignore
  /* @__PURE__ */ r.createElement(m, { size: "lg", weight: "semiBold", className: e.price, ...t })
), g = (t) => /* @__PURE__ */ r.createElement("img", { className: e.image, ...t }), it = {
  Base: s,
  Title: d,
  Description: P,
  Image: g,
  Price: C,
  Container: c,
  Tags: n,
  Footer: l
};
export {
  s as Base,
  it as BasePropertyCard,
  c as BasePropertyCardContainer,
  l as BasePropertyCardFooter,
  n as BasePropertyCardTags
};
